import {
    ACCOUNT_PURGE_ACCOUNT_OPEN_MODAL,
    ACCOUNT_PURGE_ACCOUNT_CLOSE_MODAL,
    ACCOUNT_PURGE_ACCOUNT_REQUEST,
    ACCOUNT_PURGE_ACCOUNT_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    account: null,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {

        case ACCOUNT_PURGE_ACCOUNT_OPEN_MODAL:
            return { ...state, openModal: true, account: action.payload }

        case ACCOUNT_PURGE_ACCOUNT_CLOSE_MODAL:
            return { ...state, openModal: false, account: null }

        case ACCOUNT_PURGE_ACCOUNT_REQUEST:
            return { ...state, loading: true }

        case ACCOUNT_PURGE_ACCOUNT_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "PURGE_ACCOUNT"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};